export default [
  {
    value: 'news-feed',
    label: 'News feed'
  },
  {
    value: 'objectives',
    label: 'Objectives'
  },
  {
    value: 'my-profile',
    label: 'My profile'
  },
  {
    value: 'sell-it-scanner',
    label: 'Sell IT scanner'
  }
];



// WEBPACK FOOTER //
// ./src/data/mobileAppPages.js